/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import Dropdown from '../Dropdown';
import ImageUpload from '../ImageUpload';
import TextInput from '../TextInput';
import Checkbox from '../Checkbox';
function isDropdown(field) {
    return field.staticProperties.type === 'dropdown';
}
function isImageUpload(field) {
    return field.staticProperties.type === 'image';
}
function isTextInput(field) {
    return field.staticProperties.type === 'text';
}
function isCheckbox(field) {
    return field.staticProperties.type === 'checkbox';
}
const rootCss = css `
  display: grid;
  grid-gap: 30px;
  margin: '15px 0px';
`;
/**
 * Renders a list of fields of various types. Picks which component to render
 * each field with given the field's type.
 */
const Fields = ({ fields }) => {
    return (isolateComponent("div", { css: rootCss }, fields.map((field, i) => {
        if (isDropdown(field)) {
            return isolateComponent(Dropdown, Object.assign({}, field, { key: i }));
        }
        else if (isImageUpload(field)) {
            return isolateComponent(ImageUpload, Object.assign({}, field, { key: i }));
        }
        else if (isTextInput(field)) {
            return isolateComponent(TextInput, Object.assign({}, field, { key: i }));
        }
        else if (isCheckbox(field)) {
            return isolateComponent(Checkbox, Object.assign({}, field, { key: i }));
        }
        return null;
    })));
};
export default Fields;
